const img = (k, ids) => ids.map((i) => `/img/${k}-${i}.jpg`);

export const CONTACT = {
  phone: "(11) 92474-3517",
  whatsapp: "5511924743517",
  email: "admreservamantiqueira@gmail.com",
  cnpj: "39.558.930/0001-09",
  address: "Estrada rural de Tabarana de baixo, S/N - Tabarana de Baixo, Serra Negra - SP, 13938-899",
};

export const CHALETS = [
  {
    id: "casa-vista",
    index: "01",
    name: "Casa Vista",
    price: 1190,
    tagline: "Contemporânea & minimalista",
    description:
      "A Casa Vista se destaca pela sua arquitetura contemporânea e minimalista. Seu interior reflete modernidade, conforto e sofisticação em cada detalhe.",
    images: img("vista", [6, 5, 8, 1, 2, 3, 9, 7, 4, 10]),
    amenities: {
      Cozinha: ["Todos os utensílios de cozinha", "Jogo de jantar", "Taças de cristal", "Geladeira", "Cooktop 4 bocas", "Forno à gás", "Air fryer", "Churrasqueira a gás", "Micro-ondas", "Filtro de água", "Cafeteira Nespresso", "Jogo de fondue"],
      Sala: ["Smart TV 55\" com streaming", "Adega de vinho climatizada", "Lareira", "Ar-condicionado quente/frio", "Alexa integrada à TV, iluminação, som e ar-condicionado"],
      Quarto: ["Cama Queen Size", "Jogo de cama Trussardi / Buddemeyer 400 fios", "Cortina blackout", "Ar-condicionado quente/frio", "Alexa integrada à iluminação, som, ar-condicionado e cortina"],
      Banheiro: ["Chuveiros duplos (aquecimento central a gás)", "Lavabo com cubas duplas", "Jogo de banho Trussardi", "Roupões Buddemeyer", "Amenities Costa Brazil", "Aquecedor de toalhas", "Secador de cabelo"],
      "Área externa": ["Estacionamento privativo", "Piscina aquecida", "Toldo solar elétrico", "Espreguiçadeiras", "Mesa com duas cadeiras", "Fogo de chão"],
    },
  },
  {
    id: "cabana-boutique",
    index: "02",
    name: "Cabana Boutique",
    price: 1050,
    tagline: "Rústica & elegante",
    description:
      "A Cabana Boutique é sinônimo de conforto e elegância. Sua arquitetura rústica proporciona um aconchego imediato, que se funde a uma curadoria rigorosa de itens de extrema qualidade.",
    images: img("boutique", [2, 1, 3, 4, 10, 5, 6, 8, 9, 7]),
    amenities: {
      Cozinha: ["Todos os utensílios de cozinha", "Jogo de jantar", "Taças de cristal", "Geladeira", "Cooktop 4 bocas", "Forno à gás", "Depurador", "Micro-ondas", "Air fryer", "Filtro de água", "Cafeteira Nespresso", "Jogo de fondue"],
      Sala: ["Smart TV 55\" com streaming", "Adega de vinho climatizada", "Lareira", "Caixa de som portátil integrada à TV", "Ar-condicionado quente/frio"],
      Quarto: ["Cama Queen Size", "Jogo de cama Trussardi / Buddemeyer 400 fios", "Cortina blackout", "Ar-condicionado quente/frio"],
      Banheiro: ["Chuveiros duplos (aquecimento central a gás)", "Jogo de banho Trussardi", "Roupões Buddemeyer", "Amenities Costa Brazil", "Secador de cabelo"],
      "Área externa": ["Estacionamento privativo", "Piscina aquecida com hidromassagem", "Espreguiçadeiras", "Pergolado", "Churrasqueira", "Fogo de chão"],
    },
  },
];

export const DECORATIONS = [
  {
    id: "basica",
    option: "Opção 1",
    name: "Básica",
    price: 350,
    image: "/img/deco-basica.jpg",
    lead: "Ambiente aconchegante para momentos especiais.",
    items: ["Pétalas de rosas sobre a cama", "Velas aromáticas decorativas", "Balões em formato de coração", "Frutas e chocolates finos"],
    ideal: "Ideal para surpresas simples e delicadas",
  },
  {
    id: "premium",
    option: "Opção 2",
    name: "Premium",
    price: 480,
    image: "/img/deco-premium.jpg",
    lead: "Cenário encantador para celebrar o amor.",
    items: ["Cama decorada com pétalas em formato de coração", "Balões no teto com fitas vermelhas", "Velas aromáticas + luminárias LED", "Bandeja com espumante, taças e morangos", "Música ambiente personalizada"],
    ideal: "Perfeito para aniversários de namoro ou pedidos especiais",
  },
  {
    id: "luxo",
    option: "Opção 3",
    name: "Luxo",
    price: 650,
    image: "/img/deco-luxo.jpg",
    lead: "Uma noite inesquecível e cheia de detalhes.",
    items: ["Caminho de pétalas até o quarto", "Cama com decoração personalizada (iniciais do casal em pétalas)", "Balões metalizados + cortina de coração", "Velas aromáticas + iluminação romântica", "Espumante, taças, frutas e fondue de chocolate", "Toalhas dobradas em formato de cisnes apaixonados"],
    ideal: "Ideal para noites de núpcias ou datas marcantes",
  },
];
